import React from 'react'
import formatDate from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import classnames from 'classnames'
import { eventIsPast } from 'shared/utils/dates'
import './WorkshopTicketStatus.scss'

function Flag({ children, className, ...rest }) {
  return (
    <span {...rest} className={classnames('workshop-ticket-status-flag', className)}>
      {children}
    </span>
  )
}

export default function WorkshopTicketStatus({
  ticketSalesEnded,
  live,
  startTicketSalesDate,
  ticketTypes,
  seatsAvailable,
}) {
  if (ticketSalesEnded) {
    return <Flag className="flag-black">Ticket Sales Are Ended</Flag>
  }

  // Some data used below comes async from parent
  if (!ticketTypes) return null
  const earlyBird = ticketTypes.find((t) => t.name === 'earlyBird')

  if (!live && startTicketSalesDate) {
    return (
      <Flag className="flag-blue">
        {earlyBird ? 'Early Bird Starts' : 'Ticket Sales Start'}:{' '}
        {formatDate(parseISO(startTicketSalesDate), 'MMM do')}
      </Flag>
    )
  } else if (live && earlyBird && earlyBird.available > 0 && !eventIsPast(earlyBird.expires)) {
    return <Flag className="flag-blue">Early Bird Available</Flag>
  } else if (seatsAvailable <= 10) {
    return <Flag className="flag-red">Limited Tickets Remaining</Flag>
  } else if (seatsAvailable <= 0) {
    return <Flag className="flag-red-solid">Sold Out</Flag>
  }

  return null
}
